// Horizontal product rail. Prev/next buttons (commandfor this element, command --prev / --next)
// scroll [data-rail-track] by about one visible page; buttons disable at either end and
// data-scrollable is set only when the row overflows. RTL-aware; instant scroll for reduced motion.
class ScrollRail extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.track = this.querySelector('[data-rail-track]');
    this.addEventListener('command', (event) => {
      if (event.command === '--next') this.#go(1);
      else if (event.command === '--prev') this.#go(-1);
    }, { signal });
    this.track?.addEventListener('scroll', () => this.#update(), { signal, passive: true });
    window.addEventListener('resize', () => this.#update(), { signal });
    this.#update();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #go(direction) {
    const track = this.track;
    if (!track) return;
    const rtl = getComputedStyle(track).direction === 'rtl';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: direction * (rtl ? -1 : 1) * track.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' });
  }

  #update() {
    const track = this.track;
    if (!track) return;
    const max = track.scrollWidth - track.clientWidth;
    const position = Math.abs(track.scrollLeft);
    this.querySelectorAll('[command="--prev"]').forEach((button) => { button.disabled = position <= 2; });
    this.querySelectorAll('[command="--next"]').forEach((button) => { button.disabled = position >= max - 2; });
    this.toggleAttribute('data-scrollable', max > 2);
  }
}

if (!customElements.get('s-scroll-rail')) customElements.define('s-scroll-rail', ScrollRail);
